import ThemeList from "../components/theme/ThemeList";

const ThemePage = () => {
  return <ThemeList />;
};
export default ThemePage;
